// @flow

import getContactSettings from '../../contactSettings/selectors';
import getSocialSettings from '../../socialSettings/selectors';
import formatTelephoneLink from '../../../helpers/formatTelephoneLink';
import type { ContactState } from '../../contactSettings/types';
import type { SocialState } from '../../socialSettings/types';
import type { State as RouterState } from '../../router/types';
import type { State as RoutesState } from '../../routes/types';

type GlobalState = {
  socialSettings: SocialState,
  contactSettings: ContactState,
  router: RouterState,
  routes: RoutesState,
};

type ContactOption = {
  mode: string,
};

type InjectedProps = {
  href: ?string,
  value: string,
};

export default (state: GlobalState) => <T: ContactOption>( // eslint-disable-line arrow-parens
  contactOptions: Array<T>,
): Array<T & InjectedProps> => {
  const contact = getContactSettings(state);
  const social = getSocialSettings(state);

  return contactOptions.map((option: T): T & InjectedProps => {
    switch (option.mode) {
      case 'telephone': {
        const phonenumber = contact.general_number;
        return {
          ...option,
          href: phonenumber ? formatTelephoneLink(phonenumber) : null,
          value: phonenumber,
        };
      }
      case 'email': {
        const email = contact.general_email_address;
        return {
          ...option,
          href: email ? `mailto:${email}` : null,
          value: email,
        };
      }
      case 'address': {
        let address = '';
        if (contact.address && contact.address.street && contact.address.city) {
          address = `${contact.address.street}, ${contact.address.city}`;
        }
        return {
          ...option,
          href: address ? `https://maps.google.com/?q=${address}` : null,
          value: address,
        };
      }
      case 'facebook':
        return {
          ...option,
          href: social.facebook,
          value: 'Facebook',
        };
      default:
        return {
          ...option,
          href: null,
          value: '',
        };
    }
  });
};
